import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }

type Props = {
	duration?: string;
	boardType?: string;
	transport?: string;
	extra?: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'StayDetails',
  props: {
    duration: {},
    boardType: {},
    transport: {},
    extra: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", null, [
    (_ctx.duration)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.duration), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    (_ctx.boardType)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.boardType), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    (_ctx.transport)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.transport), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    (_ctx.extra)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.extra), 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})